export * from './TextWithColumnsType';
